import { render, staticRenderFns } from "./event-preview.vue?vue&type=template&id=5f0ed942&scoped=true"
import script from "./event-preview.vue?vue&type=script&lang=js"
export * from "./event-preview.vue?vue&type=script&lang=js"
import style0 from "./event-preview.vue?vue&type=style&index=0&id=5f0ed942&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0ed942",
  null
  
)

export default component.exports